import { render, staticRenderFns } from "./ReviewedInvoices.vue?vue&type=template&id=1f6dfd1a&scoped=true&"
import script from "./ReviewedInvoices.vue?vue&type=script&lang=js&"
export * from "./ReviewedInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ReviewedInvoices.vue?vue&type=style&index=0&id=1f6dfd1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6dfd1a",
  null
  
)

export default component.exports